<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="pt-3 pb-0 text-right" >
          <b-button v-if="saveNeeded" variant="warning" class="btn-pill font-lg" style="color: white" @click="onCancel">
            Abbrechen
          </b-button>
          <b-button v-if="saveNeeded" variant="success" class="btn-pill font-lg ml-2" style="color: white" @click="onSave">
            Speichern
          </b-button>
          <b-button variant="primary" class="btn-pill font-lg ml-2" style="color: white" v-on:click="onBack">
            &nbsp;Zurück
          </b-button>

        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-sheet
              color="white"
              elevation="1"
              class="m-2"
              >
            <v-row>
              <v-col>
                <v-card-title>Einstellungen</v-card-title>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pl-8">
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rufbereitschaftseinsätze berechnen</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an ob Zuschläge, Rundungen und Wegzeit für Rufbereitschaftseinsätze berechnet werden sollen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-switch
                        class="mt-0"
                        :true-value="'true'"
                        :false-value="'false'"
                        v-model="use_rb_cal.value"
                        @change="setSaveAble"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Grundzuschlag für Einsätze</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an wann der Gundzuschlag für für Rufbereitschaftseinsätze berechnet werden soll.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-radio-group class="mt-0"
                                   v-model="rb_surcharge_only_after_soll.value"
                                   @change="setSaveAble">
                      <v-radio
                          :key="'always'"
                          :label="'ganzer Einsatz'"
                          :value="'false'"
                      ></v-radio>
                      <v-radio
                          :key="'after_soll'"
                          :label="'über Tagessollzeit'"
                          :value="'true'"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rundungsauftrag</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an ob und auf welchen Auftrag die Rundungen abgerechnet werden, falls bei der Berechnung gerundet wird.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field class="mt-0 pt-0 rb-ellipsis"
                                  readonly
                                  v-model="rb_round_task.name"
                                  @click="onChangeRoundingTask"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Einschränkung: Leistungsgruppen</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Wenn Leistungsgruppen ausgewählt sind, werden Einsätze nur dann als Rufbereitschaftseinsatz gewertet, falls sie mit den Leistungsgruppen übereinstimmen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field class="mt-0 pt-0 rb-ellipsis"
                                  readonly
                                  v-model="legrNames"
                                  @click="onChangeRestrictionsLegr"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Einschränkung: Auftragsgruppen</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Wenn Auftragsgruppen ausgewählt sind, werden Einsätze nur dann als Rufbereitschaftseinsatz gewertet, falls sie mit den Auftragsgruppen übereinstimmen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field class="mt-0 pt-0 rb-ellipsis"
                                  v-model="augrNames"
                                  @click="onChangeRestrictionsAugr"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Lohnart: Überstunden in RB</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Die hier ausgewählte Lohnart wird anstatt der Standartüberstunden-Lohnart gebucht, falls die Überstunde während eines Rufbereitschaftseinsatzes erbracht wurde.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field class="mt-0 pt-0 rb-ellipsis"
                                  v-model="ueb_geleistet_in_rb.name"
                                  @click="onChangeUebInRb"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider vertical/>
              <v-col style="padding-right: 22px">
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Raster: Feiertage</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an welcher Rasterwert an Feiertagen gebucht werden soll. Entweder wird der normale Tageswert gebucht oder der Rasterwert eines Sonntages.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-radio-group class="mt-0"
                                   v-model="use_sun_for_holidays.value"
                    @change="setSaveAble">
                      <v-radio
                          :key="'normal'"
                          :label="'Tagesraster'"
                          :value="'false'"
                      ></v-radio>
                      <v-radio
                          :key="'sun'"
                          :label="'Sonntagsraster'"
                          :value="'true'"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rufbereitschaften</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Definiert, welche Lohnarten als Rufbereitschaft gewertet werden.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field class="mt-0 pt-0 rb-ellipsis"
                                  v-model="rbNames"
                                  @click="onChangeRbs"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rufbereitschaftspauschalen berechnen</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an ob Rufbereitschaftspauschalen für die Rufbereitschaftsplanungen berechnet werden sollen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-switch
                        class="mt-0"
                        :true-value="'true'"
                        :false-value="'false'"
                        v-model="rb_use_surcharge.value"
                        @change="setSaveAble"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rufbereitschaft: Stundenweise</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Diese Pauschale wird für Rufbereitschaften berechnet, welche bis zu 12 Stunden umfassen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field class="mt-0 pt-0 rb-ellipsis"
                                  v-model="rb_surcharge_hourly.name"
                                  @click="onChangeSurcharges('hourly')"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rufbereitschaft: 2-Fach</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Diese Pauschale wird für Rufbereitschaften berechnet, welche über 12 Stunden umfassen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field class="mt-0 pt-0 rb-ellipsis"
                                  v-model="rb_surcharge_two_times.name"
                                  @click="onChangeSurcharges('two_times')"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rufbereitschaft: 4-Fach</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Diese Pauschale wird für Rufbereitschaften berechnet, welche über 12 Stunden umfassen und an Wochenenden/Feiertagen liegen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field class="mt-0 pt-0 rb-ellipsis"
                                  v-model="rb_surcharge_four_times.name"
                                  @click="onChangeSurcharges('four_times')"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Zuständigkeiten verwenden</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an ob Zuständigkeiten angezeigt werden sollen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-switch
                        class="mt-0"
                        :true-value="'true'"
                        :false-value="'false'"
                        v-model="rb_use_responsibilities.value"
                        @change="setSaveAble"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rufer verwenden</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an ob Rufer angezeigt werden sollen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-switch
                        class="mt-0"
                        :true-value="'true'"
                        :false-value="'false'"
                        v-model="rb_use_callers.value"
                        @change="setSaveAble"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

      </v-row>

      <v-dialog
          v-model="showRoundingTask"
          max-width="450px"
          persistent
          scrollable
      >
        <v-card>
          <v-card-title>
            Rundungsauftrag
          </v-card-title>
          <v-card-text>
            <v-container class="p-0">
              <v-row >
                <v-col
                >
                  <v-subheader style="height: auto; font-size: 1rem; margin-top: 12px; font-weight: bold; color: rgba(0, 0, 0, 0.87); padding-left: 0">Auftrag wählen</v-subheader>
                  <v-list style="overflow-y: auto; height: 350px; border: 1px solid lightgrey;">
                    <v-list-group
                        v-for="(augr, j) in sortedAugrs"
                        :key="j">
                      <template v-slot:activator>
                        <v-list-item-title v-text="augr.name"></v-list-item-title>
                        <v-divider></v-divider>
                      </template>
                      <v-list-item-group
                          v-model="selectedAssignment">
                        <template v-for="(task, i) in sortedTasks(augr.gischl)">
                        <v-divider class="m-0"
                            :key="`divider-${i}`"
                        ></v-divider>
                        <v-list-item

                            :key="task.id"
                            :value="task"
                        >
                          <v-list-item-content>
                            <v-list-item-title v-text="task.object"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        </template>
                      </v-list-item-group>
                    </v-list-group>
                  </v-list>
                  <v-subheader style="height: auto; font-size: 1rem; margin-top: 18px; margin-bottom: 12px; font-weight: bold; color: rgba(0, 0, 0, 0.87); padding-left: 0">Leistungsgruppe wählen</v-subheader>
                  <v-select
                      v-model="selectedLegr"
                      :items="sortedLegrs"
                      item-text="name"
                      item-value="gischl"
                      label="Leistungsgruppe wählen"
                      hide-details="true"
                      no-data-text="Keine Leistungsgruppen gefunden."
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelRoundingTask"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                :disabled="(selectedLegr == null && selectedAssignment != null) || (selectedLegr != null && selectedAssignment == null)"
                @click="onSubmitRoundingTask"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showLegrRestrictions"
          max-width="450px"
          persistent
          scrollable
      >
        <v-card>
          <v-card-title>
            Einschränkung: Leistungsgruppen
          </v-card-title>
          <v-card-text>
            <v-container class="p-0">
              <v-row >
                <v-col
                >
                  <v-list style="overflow-y: auto; height: 350px; border: 1px solid lightgrey;">
                    <v-list-item-group
                        v-model="selectedLegrs"
                        color="primary"
                        multiple
                    >
                      <v-list-item
                          v-for="(legr, i) in sortedLegrs"
                          :key="legr.id"
                          :value="legr.gischl"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-text="legr.name"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelRestrictionsLegr"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitRestrictionsLegr"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showAugrRestrictions"
          max-width="450px"
          persistent
          scrollable
      >
        <v-card>
          <v-card-title>
            Einschränkung: Auftragsgruppen
          </v-card-title>
          <v-card-text>
            <v-container class="p-0">
              <v-row >
                <v-col
                >
                  <v-list style="overflow-y: auto; height: 350px; border: 1px solid lightgrey;">
                    <v-list-item-group
                        v-model="selectedAugrs"
                        color="primary"
                        multiple
                    >
                      <v-list-item
                          v-for="(augr, i) in sortedAugrs"
                          :key="augr.id"
                          :value="augr.gischl"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-text="augr.name"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelRestrictionsAugr"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitRestrictionsAugr"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showUebInRb"
          max-width="450px"
          persistent
          scrollable
      >
        <v-card>
          <v-card-title>
            Lohnart: Überstunden in RB
          </v-card-title>
          <v-card-text>
            <v-container class="p-0">
              <v-row >
                <v-col
                >
                  <v-list style="overflow-y: auto; height: 350px; border: 1px solid lightgrey;">
                    <v-list-item-group
                        v-model="selectedUebInRb"
                        color="primary"
                    >
                      <v-list-item
                          v-for="(lohn, i) in sortedUebInRb"
                          :key="lohn.id"
                          :value="lohn.id"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-text="lohn.name"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelUebInRb"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitUebInRb"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showSurcharges"
          max-width="450px"
          persistent
          scrollable
      >
        <v-card>
          <v-card-title v-if="surchargesType === 'hourly'">
            Pauschale: Stundenweise
          </v-card-title>
          <v-card-title v-else-if="surchargesType === 'two_times'">
            Pauschale: 2-Fach
          </v-card-title>
          <v-card-title v-else>
            Pauschale: 4-Fach
          </v-card-title>
          <v-card-text>
            <v-container class="p-0">
              <v-row >
                <v-col
                >
                  <v-list style="overflow-y: auto; height: 350px; border: 1px solid lightgrey;">
                    <v-list-item-group
                        v-model="selectedSurcharge"
                        color="primary"
                    >
                      <v-list-item
                          v-for="(lohn, i) in sortedSurcharges"
                          :key="lohn.id"
                          :value="lohn.id"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-text="lohn.name"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelSurcharges"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitSurcharges"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showRbs"
          max-width="450px"
          persistent
          scrollable
      >
        <v-card>
          <v-card-title>
            Rufbereitschaften
          </v-card-title>
          <v-card-text>
            <v-container class="p-0">
              <v-row >
                <v-col
                >
                  <v-list style="overflow-y: auto; height: 350px; border: 1px solid lightgrey;">
                    <v-list-item-group
                        v-model="selectedRbs"
                        color="primary"
                        multiple
                    >
                      <v-list-item
                          v-for="(rb, i) in sortedPossibleRb"
                          :key="rb.id"
                          :value="rb.id"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-text="rb.name"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelRbs"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitRbs"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-main>
</template>


<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy";

export default {
  name: "RbSettings",
  data: () => ({

    dummyText: "dummytext",

    // controls
    saveNeeded: false,
    loader: undefined,

    use_rb_cal:                   {value: "false"},
    rb_surcharge_only_after_soll: {value: "false"},
    rb_round_task:                {name: ""},
    legr_restrictions:            [],
    augr_restrictions:            [],
    ueb_geleistet_in_rb:          {name: ""},
    use_sun_for_holidays:         {value: "true"},
    rb_use_surcharge:             {value: "true"},
    rb_use_diff_surcharges:       {value: "false"},
    rbs:                          [],
    rbs_map:                      {},
    rb_surcharge_hourly:          {name: ""},
    rb_surcharge_two_times:       {name: ""},
    rb_surcharge_four_times:      {name: ""},
    rb_use_responsibilities:       {value: "false"},
    rb_use_callers:       {value: "false"},


    augrs: null,
    assignments: null,
    legrs: null,
    lohns_ueb_rb: null,
    possible_rb: null,
    surcharges: null,

    // rounding task
    showRoundingTask: false,
    selectedAssignment: null,
    selectedLegr: null,

    // restrictions legr
    showLegrRestrictions: false,
    selectedLegrs: [],

    // restrictions augr
    showAugrRestrictions: false,
    selectedAugrs: [],

    // ueb in rb
    showUebInRb: false,
    selectedUebInRb: null,

    // rbs
    showRbs: false,
    selectedRbs: [],

    // surcharges
    showSurcharges: false,
    surchargesType: "hourly",
    selectedSurcharge: null,
  }),
  computed: {
    legrNames() {
      if (this.legr_restrictions.length === 0) {
        return ""
      } else if (this.legr_restrictions.length === 1) {
        return this.legr_restrictions[0].name
      }
      return this.legr_restrictions.reduce(function (a, b) {
        return (a.name || a) + ", " + b.name}
      )
    },
    augrNames() {
      if (this.augr_restrictions.length === 0) {
        return ""
      } else if (this.augr_restrictions.length === 1) {
        return this.augr_restrictions[0].name
      }
      return this.augr_restrictions.reduce(function (a, b) {
        return (a.name || a) + ", " + b.name}
      )
    },
    rbNames() {
      if (this.rbs.length === 0) {
        return ""
      } else if (this.rbs.length === 1) {
        return this.rbs[0].value
      }
      return this.rbs.reduce(function (a, b) {
        return (a.value || a) + ", " + b.value}
      )
    },
    sortedAugrs() {
      if (this.augrs === null || this.augrs.length === 0) {
        return []
      }
      return _orderBy(this.augrs, [val => val.name.toLowerCase()]);
    },
    sortedLegrs() {
      if (this.legrs === null || this.legrs.length === 0) {
        return []
      }
      return _orderBy(this.legrs, [val => val.name.toLowerCase()]);
    },
    sortedUebInRb() {
      if (this.lohns_ueb_rb === null || this.lohns_ueb_rb.length === 0) {
        return []
      }
      return _orderBy(this.lohns_ueb_rb, [val => val.name.toLowerCase()]);
    },
    sortedSurcharges() {
      if (this.surcharges === null || this.surcharges.length === 0) {
        return []
      }
      return _orderBy(this.surcharges, [val => val.name.toLowerCase()]);
    },
    sortedPossibleRb() {
      if (this.possible_rb === null || this.possible_rb.length === 0) {
        return []
      }
      return _orderBy(this.possible_rb, [val => val.name.toLowerCase()]);
    },
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/rufbereitschaft/settings'
    ).then(this.responseOkGet, this.responseError)
  },
  methods: {
    sortedTasks(augr) {
      if (this.assignments === null || this.assignments[augr] === undefined || this.assignments[augr].length === 0) {
        return []
      }
      return _orderBy(this.assignments[augr], [val => val.object.toLowerCase()]);
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      this.saveNeeded = false;
      if (response.status === 200) {
        let res = response.body;
        this.use_rb_cal = res.use_rb_cal;
        this.rb_surcharge_only_after_soll = res.rb_surcharge_only_after_soll;
        this.rb_round_task = res.rb_round_task;
        this.legr_restrictions = res.legr_restrictions;
        this.augr_restrictions = res.augr_restrictions;
        this.ueb_geleistet_in_rb = res.ueb_geleistet_in_rb;
        this.use_sun_for_holidays = res.use_sun_for_holidays;
        this.rb_use_surcharge = res.rb_use_surcharge;
        this.rb_use_diff_surcharges = res.rb_use_diff_surcharges;
        this.rbs = res.rbs;
        this.rbs_map = res.rbs_map;
        this.rb_surcharge_hourly = res.rb_surcharge_hourly;
        this.rb_surcharge_two_times = res.rb_surcharge_two_times;
        this.rb_surcharge_four_times = res.rb_surcharge_four_times;
        this.rb_use_responsibilities = res.rb_use_responsibilities;
        this.rb_use_callers = res.rb_use_callers;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkPost(response) {
      this.hideLoader();
      this.saveNeeded = false;
      if (response.status === 200) {
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      console.log(response);
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    onBack() {
      window.history.back();
    },
    onSave() {
      let data = {
        use_rb_cal:                   this.use_rb_cal,
        rb_surcharge_only_after_soll: this.rb_surcharge_only_after_soll,
        rb_round_task:                this.rb_round_task,
        legr_restrictions:            this.legr_restrictions,
        augr_restrictions:            this.augr_restrictions,
        ueb_geleistet_in_rb:          this.ueb_geleistet_in_rb,
        use_sun_for_holidays:         this.use_sun_for_holidays,
        rb_use_surcharge:             this.rb_use_surcharge,
        rb_use_diff_surcharges:       this.rb_use_diff_surcharges,
        rbs:                          this.rbs,
        rbs_map:                      this.rbs_map,
        rb_surcharge_hourly:          this.rb_surcharge_hourly,
        rb_surcharge_two_times:       this.rb_surcharge_two_times,
        rb_surcharge_four_times:      this.rb_surcharge_four_times,
        rb_use_responsibilities:      this.rb_use_responsibilities,
        rb_use_callers:               this.rb_use_callers,
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/settings', data
      ).then(this.responseOkPost, this.responseError)
    },
    onCancel() {
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/rufbereitschaft/settings'
      ).then(this.responseOkGet, this.responseError)
    },
    setSaveAble() {
      this.saveNeeded = true;
    },
    onChangeRoundingTask() {
      if (this.assignments !== null) {
        this.onShowRoundingTask();
      } else {
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/rufbereitschaft/settings/assignments'
        ).then(this.responseOkGetAssignments, this.responseError)
      }
    },
    responseOkGetAssignments(response) {
      this.hideLoader();
      if (response.status === 200) {
        let res = response.body;
        this.assignments = res.assignments;
        this.legrs = res.legrs;
        this.augrs = res.augrs;
        console.log(this.augrs)
        this.onShowRoundingTask();
      } else {
        window.location = Redirect_500;
      }
    },
    onShowRoundingTask() {
      this.showRoundingTask = true;
    },
    onCancelRoundingTask() {
      this.showRoundingTask = false;
      this.selectedAssignment = null;
      this.selectedLegr = null;
    },
    onSubmitRoundingTask() {
      this.saveNeeded = true;
      if (this.selectedAssignment == null) {
        this.rb_round_task.name = "";
        this.rb_round_task.value = "";
      } else {
        let legr = null;
        for (let i = 0; i < this.legrs.length; i++) {
          if (this.legrs[i].gischl === this.selectedLegr) {
            legr = this.legrs[i];
            break
          }
        }
        if (legr !== null) {
          if (this.selectedLegr.length > 4) {
            this.selectedLegr = this.selectedLegr.substring(this.selectedLegr.length - 4, this.selectedLegr.length)
          } else {
            this.selectedLegr = this.selectedLegr.padStart(4, "0")
          }
          this.rb_round_task.value = `${this.selectedAssignment.aufisn}.${this.selectedLegr}`;
          this.rb_round_task.name = `${this.selectedAssignment.object}, ${legr.name}`;
        } else {
          this.rb_round_task.name = "";
          this.rb_round_task.value = "";
        }
      }
      this.onCancelRoundingTask();
    },
    onChangeRestrictionsLegr() {
      if (this.legrs !== null) {
        this.onShowRestrictionsLegr();
      } else {
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/rufbereitschaft/settings/legrs'
        ).then(this.responseOkGetLegrs, this.responseError)
      }
    },
    responseOkGetLegrs(response) {
      this.hideLoader();
      if (response.status === 200) {
        let res = response.body;
        this.legrs = res.legrs;
        this.onShowRestrictionsLegr();
      } else {
        window.location = Redirect_500;
      }
    },
    onShowRestrictionsLegr() {
      this.selectedLegrs = [];
      for (let i = 0; i < this.legr_restrictions.length; i++) {
        this.selectedLegrs.push(this.legr_restrictions[i].value.padStart(6, "0"))
      }
      this.showLegrRestrictions = true;
    },
    onCancelRestrictionsLegr() {
      this.showLegrRestrictions = false;
      this.selectedLegrs = [];
    },
    onSubmitRestrictionsLegr() {
      this.saveNeeded = true;
      if (this.selectedLegrs.length === 0) {
        this.legr_restrictions = []
      } else {
        let legrs = [];
        for (let i = 0; i < this.selectedLegrs.length; i++) {
          for (let j = 0; j < this.legrs.length; j++) {
            if (this.legrs[j].gischl === this.selectedLegrs[i]) {
              let gischl = this.legrs[j].gischl;
              if (gischl.length > 4) {
                gischl = gischl.substring(gischl.length - 4, gischl.length)
              } else {
                gischl = gischl.padStart(4, "0")
              }
              legrs.push({
                type: "rbr_restriction_legr",
                web_server_id: this.legrs[j].id,
                value: this.legrs[j].gischl,
                name: this.legrs[j].name,
              });
              break
            }
          }
        }
        if (legrs.length === 0) {
          this.legr_restrictions = []
        } else {
          this.legr_restrictions = legrs
        }
        console.log(this.legr_restrictions)
      }
      this.onCancelRestrictionsLegr();
    },

    onChangeRestrictionsAugr() {
      if (this.augrs !== null) {
        this.onShowRestrictionsAugr();
      } else {
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/rufbereitschaft/settings/augrs'
        ).then(this.responseOkGetAugrs, this.responseError)
      }
    },
    responseOkGetAugrs(response) {
      this.hideLoader();
      if (response.status === 200) {
        let res = response.body;
        this.augrs = res.augrs;
        this.onShowRestrictionsAugr();
      } else {
        window.location = Redirect_500;
      }
    },
    onShowRestrictionsAugr() {
      this.selectedAugrs = [];
      for (let i = 0; i < this.augr_restrictions.length; i++) {
        this.selectedAugrs.push(this.augr_restrictions[i].value)
      }
      this.showAugrRestrictions = true;
    },
    onCancelRestrictionsAugr() {
      this.showAugrRestrictions = false;
      this.selectedAugrs = [];
    },
    onSubmitRestrictionsAugr() {
      this.saveNeeded = true;
      if (this.selectedAugrs.length === 0) {
        this.augr_restrictions = []
      } else {
        let augrs = [];
        for (let i = 0; i < this.selectedAugrs.length; i++) {
          for (let j = 0; j < this.augrs.length; j++) {
            if (this.augrs[j].gischl === this.selectedAugrs[i]) {
              let gischl = this.augrs[j].gischl;
              if (gischl.length > 4) {
                gischl = gischl.substring(gischl.length - 4, gischl.length)
              } else {
                gischl = gischl.padStart(4, "0")
              }
              augrs.push({
                type: "rbr_restriction_augr",
                web_server_id: this.augrs[j].id,
                value: this.augrs[j].gischl,
                name: this.augrs[j].name,
              });
              break
            }
          }
        }
        if (augrs.length === 0) {
          this.augr_restrictions = []
        } else {
          this.augr_restrictions = augrs
        }
      }
      this.onCancelRestrictionsAugr();
    },

    onChangeUebInRb() {
      if (this.lohns_ueb_rb !== null) {
        this.onShowUebInRb();
      } else {
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/rufbereitschaft/settings/ueb_rb'
        ).then(this.responseOkGetUebInRb, this.responseError)
      }
    },
    responseOkGetUebInRb(response) {
      this.hideLoader();
      if (response.status === 200) {
        let res = response.body;
        this.lohns_ueb_rb = res.lohns;
        this.onShowUebInRb();
      } else {
        window.location = Redirect_500;
      }
    },
    onShowUebInRb() {
      if (this.ueb_geleistet_in_rb.web_server_id === "") {
        this.selectedUebInRb = null;
      } else {
        this.selectedUebInRb = this.ueb_geleistet_in_rb.web_server_id
      }
      this.showUebInRb = true;
    },
    onCancelUebInRb() {
      this.showUebInRb = false;
      this.selectedUebInRb = null;
    },
    onSubmitUebInRb() {
      this.saveNeeded = true;
      console.log(this.selectedUebInRb)
      if (this.selectedUebInRb === undefined || this.selectedUebInRb === null) {
        this.ueb_geleistet_in_rb = {
          id: "",
          web_server_id: "",
          name: "",
        }
      } else {
        for (let i = 0; i < this.lohns_ueb_rb.length; i++) {
          if (this.selectedUebInRb === this.lohns_ueb_rb[i].id) {
            this.ueb_geleistet_in_rb.name = this.lohns_ueb_rb[i].name;
            this.ueb_geleistet_in_rb.web_server_id = this.lohns_ueb_rb[i].id;
            break
          }
        }
      }
      this.onCancelUebInRb();
    },

    onChangeSurcharges(surchargeType) {
      this.surchargesType = surchargeType;
      if (this.surcharges !== null) {
        this.onShowSurcharges();
      } else {
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/rufbereitschaft/settings/surcharge'
        ).then(this.responseOkGetSurcharges, this.responseError)
      }
    },
    responseOkGetSurcharges(response) {
      this.hideLoader();
      if (response.status === 200) {
        let res = response.body;
        this.surcharges = res.lohns;
        this.onShowSurcharges();
      } else {
        window.location = Redirect_500;
      }
    },
    onShowSurcharges() {
      if (this.surchargesType === "hourly") {
        if (this.rb_surcharge_hourly.web_server_id === "") {
          this.selectedSurcharge = null;
        } else {
          this.selectedSurcharge = this.rb_surcharge_hourly.web_server_id
        }
      } else if (this.surchargesType === "two_times") {
        if (this.rb_surcharge_two_times.web_server_id === "") {
          this.selectedSurcharge = null;
        } else {
          this.selectedSurcharge = this.rb_surcharge_two_times.web_server_id
        }
      } else {
        if (this.rb_surcharge_four_times.web_server_id === "") {
          this.selectedSurcharge = null;
        } else {
          this.selectedSurcharge = this.rb_surcharge_four_times.web_server_id
        }
      }
      console.log(this.surchargesType);
      console.log(this.rb_surcharge_hourly);
      console.log(this.rb_surcharge_two_times);
      console.log(this.rb_surcharge_four_times);
      console.log(this.selectedSurcharge);
      console.log(this.surcharges);
      this.showSurcharges = true;
    },
    onCancelSurcharges() {
      this.showSurcharges = false;
      this.selectedSurcharge = null;
    },
    onSubmitSurcharges() {
      this.saveNeeded = true;
      if (this.selectedSurcharge === undefined || this.selectedSurcharge === null) {
        if (this.surchargesType === "hourly") {
          this.rb_surcharge_hourly = {
            id: "",
            web_server_id: "",
            name: "",
          }
        } else if (this.surchargesType === "two_times") {
          this.rb_surcharge_two_times = {
            id: "",
            web_server_id: "",
            name: "",
          }
        } else {
          this.rb_surcharge_four_times = {
            id: "",
            web_server_id: "",
            name: "",
          }
        }
      } else {
        let sur = {
          id: "",
          web_server_id: "",
          name: "",
        };
        for (let i = 0; i < this.surcharges.length; i++) {
          if (this.selectedSurcharge === this.surcharges[i].id) {
            sur = {
              id: "",
              web_server_id: this.surcharges[i].id,
              name: this.surcharges[i].name,
            };
          }
        }
        if (this.surchargesType === "hourly") {
          this.rb_surcharge_hourly = sur
        } else if (this.surchargesType === "two_times") {
          this.rb_surcharge_two_times = sur
        } else {
          this.rb_surcharge_four_times = sur
        }
      }
      this.onCancelSurcharges();
    },

    onChangeRbs() {
      if (this.possible_rb !== null) {
        this.onShowRbs();
      } else {
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/rufbereitschaft/settings/rbs'
        ).then(this.responseOkGetRbs, this.responseError)
      }
    },
    responseOkGetRbs(response) {
      this.hideLoader();
      if (response.status === 200) {
        let res = response.body;
        this.possible_rb = res.lohns;
        this.onShowRbs();
      } else {
        window.location = Redirect_500;
      }
    },
    onShowRbs() {
      this.selectedRbs = [];
      for (let i = 0; i < this.rbs.length; i++) {
        this.selectedRbs.push(this.rbs[i].web_server_id)
      }
      this.showRbs = true;
    },
    onCancelRbs() {
      this.showRbs = false;
      this.selectedRbs = [];
    },
    onSubmitRbs() {
      this.saveNeeded = true;
      if (this.selectedRbs.length === 0) {
        this.rbs = []
      } else {
        let rbs = [];
        for (let i = 0; i < this.selectedRbs.length; i++) {
          for (let j = 0; j < this.possible_rb.length; j++) {
            if (this.possible_rb[j].id === this.selectedRbs[i]) {
              rbs.push({
                type: "rb_lohn",
                web_server_id: this.possible_rb[j].id,
                value: this.possible_rb[j].name,
              });
              break
            }
          }
        }
        if (rbs.length === 0) {
          this.rbs = []
        } else {
          this.rbs = rbs
        }
      }
      this.onCancelRbs();
    },
  }
}
</script>

<style scoped>
.v-input::v-deep .v-label {
  margin-bottom: 0;
}

.rb-ellipsis::v-deep > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}



</style>
